import { BrowserNames } from "./types";

export const getCookie = (name: string): string | undefined => {
  const cookie: Record<string, string> = {};
  document.cookie.split(";").forEach((el) => {
    const [k, v] = el.split("=");
    cookie[k.trim()] = v;
  });
  return cookie[name];
};

export const setCookie = (name: string, value: string | number | boolean) => {
  const date = new Date();
  date.setTime(date.getTime() + 100 * 365 * 24 * 60 * 60 * 1000); // Expires in 100 years
  const expires = "; expires=" + date.toUTCString();
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    expires +
    "; path=/; SameSite=strict; Secure";
};

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isMobileDevice(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || window.navigator.userAgent
  );
}

export function detectBrowser(): BrowserNames {
  const userAgent = navigator.userAgent || window.navigator.userAgent;
  if (userAgent.includes(BrowserNames.CHROME)) return BrowserNames.CHROME;
  if (userAgent.includes(BrowserNames.FIREFOX)) return BrowserNames.FIREFOX;
  if (userAgent.includes(BrowserNames.SAFARI)) return BrowserNames.SAFARI;

  return BrowserNames.UNKNOWN;
}
